import { render } from "./App.vue?vue&type=template&id=ce08faae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ce08faae&lang=scss"

import exportComponent from "D:\\Hbuilder\\website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__